<!-- eslint-disable @angular-eslint/template/conditional-complexity -->
<div
    class="nav-submenu-item {{ subCategory.className }}"
    [class.is-rtl]="isRtl"
    [class.is-first]="indexItem === 0"
    [class.is-active]="
        !!activeCategories &&
        (activeCategories[sectionIndex]?.activeCategoryIdLvl2 === subCategory.id ||
            activeCategories[sectionIndex]?.activeCategoryIdLvl3 === subCategory.id)
    "
>
    <div class="nav-menu-item-category">
        <a
            *ngIf="!isNoindex"
            [title]="subCategory.name + ' ' + sectionName | headerItemTitle"
            [href]="subCategory.locationPath"
            [style.--color]="subCategory.labelColor"
            [id]="subCategory.id"
            (click)="openSubCategory($event, subCategory)"
            [class.text-underline]="
                level === 2 &&
                !!activeCategories &&
                activeCategories[sectionIndex]?.activeCategoryIdLvl2 === subCategory.id &&
                subCategory.subcategories?.length === 0
            "
            class="nav-submenu-item-link text-m level-{{ level }}"
        >
            <span class="category-name">{{ subCategory.name }}</span>
            <span *ngIf="debugShowCategoryId">{{ subCategory.id }}</span>
        </a>
        <ng-container *ngTemplateOutlet="categoryTags"></ng-container>
        <button
            *ngIf="isNoindex"
            [title]="subCategory.name + ' ' + sectionName | headerItemTitle"
            [style.--color]="subCategory.labelColor"
            [id]="subCategory.id"
            (click)="openSubCategory($event, subCategory)"
            [class.text-underline]="
                level === 2 &&
                !!activeCategories &&
                activeCategories[sectionIndex]?.activeCategoryIdLvl2 === subCategory.id &&
                subCategory.subcategories?.length === 0
            "
            class="btn nav-submenu-item-link btn-noindex text-m level-{{ level }}"
        >
            {{ subCategory.name }}
            <span *ngIf="debugShowCategoryId">{{ subCategory.id }}</span>
            <ng-container *ngTemplateOutlet="categoryTags"></ng-container>
        </button>
    </div>
    <ul
        class="nav-sub-submenu-list"
        [id]="'nav-submenu-list-' + subCategory.id"
        *ngIf="showChilds && subCategory.subcategories?.length > 0"
        [class.active]="
            (!!activeCategories && activeCategories[sectionIndex]?.activeCategoryIdLvl2 === subCategory.id) || subCategory.isBlockCategories
        "
    >
        <ng-container *ngFor="let subSubCategory of subCategory.subcategories; index as i">
            <li
                header-menu-subcategory
                [indexItem]="i"
                [sectionIndex]="sectionIndex"
                [activeCategories]="activeCategories"
                [sectionName]="sectionName"
                [isRtl]="isRtl"
                [subCategory]="subSubCategory"
                [showChilds]="false"
                [level]="level + 1"
                [debugShowCategoryId]="debugShowCategoryId"
                (sendOpenSubCategory)="sendOpenSubCategory.emit(subSubCategory)"
            ></li>
        </ng-container>
    </ul>
</div>

<ng-template #categoryTags>
    <div *ngIf="subCategory.isNew || freeTextAttachments?.length" class="attachments-text">
        <div class="text-m p-tag pl-8" *ngIf="subCategory.isNew" [style.color]="subCategory.labelColor">NEW</div>
        <div class="text-m p-tag pl-8" *ngFor="let freeTextAttachment of freeTextAttachments" [style.color]="subCategory.labelColor">
            {{ freeTextAttachment.path }}
        </div>
    </div>
</ng-template>
